<template>
  <div class="war-room-landing-video" @click="handleOpen">
    <div class="war-room-landing-video__preview">
      <slot />
    </div>
    <portal v-if="videoOpened" to="video-overlay">
      <div class="war-room-landing-video__overlay" @click="handleClose">
        <div class="war-room-landing-video__content">
          <CloseIcon width="32px" height="32px" class="war-room-landing-video__close" @click="handleClose" />
          <div class="war-room-landing-video__player">
            <iframe
              allow="autoplay"
              allowfullscreen
              frameborder="0"
              class="war-room-landing-video__frame"
              :src="video"
            />
          </div>
        </div>
      </div>
    </portal>
  </div>
</template>

<script lang="ts">
import type { PropOptions } from 'vue';
import Vue from 'vue';
import CloseIcon from '@/assets/svg/close.vue.svg';

interface IData {
  videoOpened: boolean;
  video: string;
}

export default Vue.extend({
  name: 'WarRoomLandingVideo',
  components: {
    CloseIcon,
  },
  props: {
    videoId: {
      type: String,
      required: true,
      default: null,
    } as PropOptions<string>,
  },
  data(): IData {
    return {
      videoOpened: false,
      video: `//www.youtube.com/embed/${this.videoId}?showinfo=0&autoplay=1&enablejsapi=1`,
    };
  },
  methods: {
    handleOpen(): void {
      this.videoOpened = true;
    },
    handleClose(): void {
      this.videoOpened = false;
    },
  },
});
</script>

<style scoped lang="scss">
.war-room-landing-video {
  $this: &;

  text-align: center;
  line-height: 0;

  &__preview {
    cursor: pointer;
    position: relative;
  }

  &__overlay {
    background: var(--black-a60);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 300;
  }

  &__content {
    width: 90%;
    max-width: 1024px;
    max-height: 577px;
    line-height: 0;
    position: relative;
  }

  &__player {
    @include aspect-ratio-container(calc(9 / 16));

    height: 0;
    position: relative;
    line-height: 0;
  }

  &__frame {
    @include aspect-ratio-content;
  }

  &__close {
    position: absolute;
    top: -40px;
    right: 0;
    cursor: pointer;
    color: var(--white-a50);

    &:hover {
      color: var(--white);
    }
  }

  &:hover {
    #{$this}__icon {
      color: var(--black);
    }
  }
}
</style>
